<template lang="pug">
  .zone
    .zone__wrapper(v-if="!isEditable")
      span.zone__name {{item.name}}
      .zone__buttons
        button.button.button_usual.button_edit.reset-btn(@click="() => $emit('editZone', item)") Редактировать
        button.button.button_usual.button_delete.reset-btn(@click="() => $emit('deleteZone', item)") Удалить
    .zone__edit(v-if="isEditable")
      label.label.zone__edit-name
        span Наименование
        input.input(:value="item.name" @change="(e) => $emit('changeZoneName', e)")
      label.label.zone__type
        span Тип зоны
        select.select.zone__select(@change="(e) => $emit('changeZone',(e, item))")
          option(v-for="type in types" :key="type.id" :value="type.id" :selected="item.type_id === type.id") {{type.name}}
      button.reset-btn.button.zone__update-coords(@click="() => $emit('updateCoords', item)") Обновить координаты
      .zone__bottom
        button.button(@click="() => $emit('cancelEdit', item)") Отменить
        button.button.button_save.button_green(@click="() => $emit('saveEdit', item)") Сохранить
</template>
<script>
export default {
  name: 'sanitary-zone-item',
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
    types: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
